import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { formatReportDate } from "../../utils/reportDate";

const REPORT_TYPES = [
  { key: "SalesContractReport", label: "SalesContract Report" },
  { key: "DealFixationNote", label: "Deal FixationNote" },
  { key: "PaymentAdvice", label: "Payment Advice" },
  { key: "FixationNote", label: "FixationNote" },
  { key: "ShipmentAdvice", label: "Shipment Advice" },
  { key: "DocumentDispatchAdvice", label: "Document Dispatch Advice" },
];

const ManualReportQueue = () => {
  const [reportTypes, setReportTypes] = useState([]);
  const [deals, setDeals] = useState([]);
  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    fetchDeals();
  }, []);

  const fetchDeals = async () => {
    try {
      const res = await axios.post("/newdeal/search", {});
      setDeals(Array.isArray(res.data) ? res.data : []);
    } catch {
      setDeals([]);
    }
  };

  const toggleReportType = (key) => {
    setReportTypes((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelected([]);
    } else {
      setSelected(deals.map((d) => d.DealID));
    }
    setSelectAll(!selectAll);
  };

  const toggleRow = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleAdd = async () => {
    if (selected.length === 0) return alert("Please select at least one deal.");
    if (reportTypes.length === 0) return alert("Please select at least one report type.");
    try {
      const res = await axios.post("/report/manual-queue", { dealIds: selected, reportTypes });
      alert(res.data.message || "Added to queue successfully.");
      setSelected([]);
      setSelectAll(false);
    } catch {
      alert("Failed to add to queue.");
    }
  };

  const fmt = formatReportDate;

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <span className="badge bg-success fs-6 px-3 py-2">Manual Report Que</span>
        </div>
        <div className="card-body">

          {/* Report Type Filter */}
          <div className="border rounded p-3 mb-3 bg-light">
            <div className="fw-semibold mb-2" style={{ fontSize: "13px" }}>Manual Report Que</div>
            <div className="d-flex align-items-center gap-2 flex-wrap" style={{ fontSize: "13px" }}>
              <span className="me-2">Report Type :</span>
              {REPORT_TYPES.map((rt) => (
                <div className="form-check form-check-inline mb-0" key={rt.key}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={rt.key}
                    checked={reportTypes.includes(rt.key)}
                    onChange={() => toggleReportType(rt.key)}
                  />
                  <label className="form-check-label" htmlFor={rt.key}>{rt.label}</label>
                </div>
              ))}
            </div>
          </div>

          {/* Deal Grid */}
          <div className="fw-semibold mb-2" style={{ fontSize: "13px" }}>Select Deal</div>
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered table-hover table-sm" style={{ fontSize: "13px" }}>
              <thead className="table-success">
                <tr>
                  <th style={{ width: 36 }}>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={toggleSelectAll}
                    />
                  </th>
                  <th>Deal Id</th>
                  <th>Deal Date</th>
                  <th>Container No</th>
                  <th>Buyer</th>
                  <th>Supplier</th>
                  <th>Status</th>
                  <th>Pending Status</th>
                </tr>
              </thead>
              <tbody>
                {deals.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center text-muted py-3">No records found.</td>
                  </tr>
                ) : (
                  deals.map((d, i) => (
                    <tr key={d.DealID} style={{ background: i % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selected.includes(d.DealID)}
                          onChange={() => toggleRow(d.DealID)}
                        />
                      </td>
                      <td>{d.DealID}</td>
                      <td>{fmt(d.DealDate)}</td>
                      <td>{d.ContainerNo || "-"}</td>
                      <td>{d.BuyerName || "-"}</td>
                      <td>{d.ShipperName || "-"}</td>
                      <td>{d.DealStatus || "-"}</td>
                      <td>{d.PendingStatus || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-2">
            <button className="btn btn-success btn-sm px-4" onClick={handleAdd}>
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualReportQueue;
